<div class="messages">
  <div (click)="deleteMessage(item)" *ngFor="let item of items" class="alert alert-dismissible {{item.type}}">
    <button aria-label="Close" class="btn-close" data-dismiss="alert" type="button">
      <span class="visually-hidden">&times;</span>
    </button>
    <span [innerHTML]="item.message"></span>
  </div>
</div>
